module.exports = __webpack_public_path__ + "images/emoji/circus_tent.64c91f73fff3ab74685b.png";